import React, { useState, useCallback } from 'react';
import { PasswordGate } from '../components/PasswordGate';
import { DiaryBook } from '../components/DiaryBook';
import { useDiaryEntries } from '../hooks/useDiaryEntries';

type DiaryState = 'password' | 'cover' | 'book';

type DiaryPageProps = {
  dark: boolean;
  onAdminClick: () => void;
};

export const DiaryPage = ({ dark, onAdminClick }: DiaryPageProps): React.JSX.Element => {
  const [state, setState] = useState<DiaryState>(() => {
    const hasAccess = sessionStorage.getItem('diary_access') === 'true';
    return hasAccess ? 'cover' : 'password';
  });

  const { entries, isLoading, error } = useDiaryEntries();

  const handlePasswordSuccess = useCallback(() => {
    sessionStorage.setItem('diary_access', 'true');
    setState('cover');
  }, []);

  const handleCoverClick = useCallback(() => {
    setState('book');
  }, []);

  const handleClosebook = useCallback(() => {
    setState('cover');
  }, []);

  if (state === 'password') {
    return <PasswordGate dark={dark} onSuccess={handlePasswordSuccess} onAdminClick={onAdminClick} />;
  }

  // Show both cover and book when book is open - cover visible underneath
  return (
    <DiaryBook
      dark={dark}
      entries={entries}
      isLoading={isLoading}
      error={error}
      isOpen={state === 'book'}
      onOpen={handleCoverClick}
      onClose={handleClosebook}
      onAdminClick={onAdminClick}
    />
  );
};
